import React from "react";
import styles from "./OnboardingStrategy.module.css";
import { cleanLines, stripBoldTitle, splitSentences } from "./utils";

const parseBoard = (md = "") => {
  const lines = stripBoldTitle(cleanLines(md));
  const body = lines.join(" ").trim();
  const sentences = splitSentences(body);
  return { body, sentences };
};

const MetaActivationBoard = ({ markdown = "" }) => {
  const { body, sentences } = parseBoard(markdown);
  if (!body) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>Connect Meta</h3>
      <div className={styles.card}>
        <div className={styles.sectionHeader}>
          {/* <span>M</span>
          <span className={styles.sectionLabel}>Integration Overview</span> */}
        </div>
        {sentences.length > 1 ? (
          sentences.map((sentence, idx) => (
            <div key={idx} className={styles.bulletRow}>
              <span className={styles.bulletDot} />
              <span>{sentence}</span>
            </div>
          ))
        ) : (
          <p className={styles.paragraph}>{body}</p>
        )}
      </div>
      <div className={styles.summaryCard}>
        <div className={styles.sectionHeader}>
          
          <span className={styles.sectionLabel}>Key Tools</span>
        </div>
        <div className={styles.toolsGrid}>
          <div className={styles.toolPill}>Business Suite</div>
          <div className={styles.toolPill}>Meta Pixel</div>
          <div className={styles.toolPill}>Instagram</div>
        </div>
      </div>
    </div>
  );
};

export default MetaActivationBoard;
